import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import FeedBackService from '../Services/FeedBackService';
import './FeedBack.css';
import { Rating } from 'react-simple-star-rating';
import SweetAlertService from '../../../services/SweetAlertService';
import { Link } from 'react-router-dom';

export const FeedBack = () => {
    const [starRating, setStarRating] = useState(0);
    const [comments, setComments] = useState('');
    const [isConsentToContact, setIsCheckboxChecked] = useState(false);
    const [isConfirmed, setIsConfirmed] = useState(false);
    const [hovered, setHovered] = useState(0);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();

    const onSubmit = (data: any) => {
        data.starRating = starRating;
        FeedBackService.addFeedBack(data)
            .then((res: any) => {
                if (res) {
                    setIsConfirmed(true);
                    setComments('');
                } else {
                    SweetAlertService.error("Error", "Something went wrong while submitting the FeedBack");
                }
                reset();
            })
            .catch(() => {
                SweetAlertService.error("Error", "Something went wrong while submitting the FeedBack");
            });
    };

    const handleHoverLeave = () => {
        setHovered(starRating);
    };

    const handleStarChange = (value: number) => {
        setIsConfirmed(false);
        setIsCheckboxChecked(false);
        setStarRating(value);
    };

    const handleHover = (value: number) => {
        setHovered(value);
    };

    const handleChangeComments = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        setComments(event.target.value);
        if (event.target.value.length <= 0) {
            setIsCheckboxChecked(false);
        }
    };

    const handleCheckboxChange = (event: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) => {
        setIsCheckboxChecked(event.target.checked);
    };

    const renderRatingCaption = () => {
        let caption = '';
        let backgroundColor = '';

        switch (hovered) {
            case 0:
                caption = 'Not Rated';
                backgroundColor = '#777';
                break;
            case 1:
                caption = 'One Star';
                backgroundColor = '#d9534f';
                break;
            case 2:
                caption = 'Two Stars';
                backgroundColor = '#f0ad4e';
                break;
            case 3:
                caption = 'Three Stars';
                backgroundColor = '#5bc0de';
                break;
            case 4:
                caption = 'Four Stars';
                backgroundColor = '#af1478';
                break;
            case 5:
                caption = 'Five Stars';
                backgroundColor = '#5cb85c';
                break;
            default:
                break;
        }

        const style = {
            backgroundColor: backgroundColor,
        };
        return (
            <span className={`label ${'ratingCaption'}`} style={style}>{caption}</span>
        );
    };

    return (
        <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group">
                    <fieldset className="container">
                        <div>
                            &nbsp;
                            <h2>Get support</h2>
                            <p>
                                <a href="https://www.bma.org.uk/gpdiary" target="_blank" rel="noopener noreferrer">
                                    <span className="faq-link"><u>Find out more about GP Diary on the BMA website </u></span></a>and <Link to="/faqs" className="customLink"><u>find answers to common questions about GP Diary</u></Link>.
                            </p>
                        </div>
                        <div>
                            <h2>
                                Help us improve
                            </h2>
                            <p>
                                Alternatively let us know what you think of the GP Diary and if you would like a BMA advisor to get in touch with you about your feedback.
                            </p>

                            <div className="d-inline-flex">
                                <Rating
                                    onClick={handleStarChange}
                                    initialValue={starRating}
                                    transition
                                    allowHover
                                    onPointerLeave={handleHoverLeave}
                                    onPointerMove={handleHover}
                                    fillColor="#d60054"
                                    fillClassName={`glyphicon-star ${starRating >= starRating ? 'filled' : ''}`}
                                    emptyColor="#aaa"
                                    fillIcon={<span>&#9733;</span>}
                                    emptyIcon={<span>&#9734;</span>}
                                    className="display-4"
                                    allowTitleTag={false}
                                />
                                <div className="caption k-display-inline-block mt-4 pt-0 px-1">{renderRatingCaption()}</div>
                            </div>
                        </div>

                        {comments && (
                            <div className="form-group">
                                <div className="mt-4 mb-4">
                                    <span className="text">
                                        <input className="checkbox"
                                            type="checkbox"
                                            {...register('isConsentToContact')}
                                            id="isConsentCheckbox"
                                            checked={isConsentToContact}
                                            onChange={handleCheckboxChange}
                                        />{' '}
                                        I would like to give feedback and be contacted in response.
                                    </span>
                                </div>
                            </div>
                        )}

                        {starRating > 0 && (
                            <div className="mt-3 form-group">
                                <p className="mb-3">Why did you give this rating?</p>
                                <textarea
                                    className="form-control"
                                    rows={8}
                                    {...register('comments',
                                    )}
                                    onChange={handleChangeComments}
                                    placeholder="Post your feedback here..."
                                ></textarea>
                                {comments.length > 1000 && (
                                    <span className="text-danger">
                                        Maximum 1000 characters
                                    </span>
                                )}
                            </div>
                        )}
                        &nbsp;
                        {starRating > 0 && (
                            <div>
                                <button
                                    type='submit'
                                    className="btn btn-primary mt-2"
                                >
                                    Send
                                </button>&nbsp;
                                {isConfirmed && (<span>
                                    <img className="checkmark" src={require('../../../assets/images/checkmark.png')} alt="checkbox" />Thank you for your feedback
                                </span>)}
                            </div>
                        )}
                    </fieldset>
                </div>
            </form>
        </div>
    );
};